const name = "@prismicio/client";
const version = "7.20.1";
export {
  name,
  version
};
//# sourceMappingURL=package.json.js.map
